const eventQueue = [];
let dataLayerReady = false;

function isBrowser() {
  return typeof window !== 'undefined';
}

function flushEventQueue() {
  if (!isBrowser()) return;
  dataLayerReady = true;
  window.dataLayer = window.dataLayer || [];
  while (eventQueue.length > 0) {
    window.dataLayer.push(eventQueue.shift());
  }
}

function getStapeScript() {
  if (typeof document === 'undefined') return null;
  return document.querySelector('script[src*="sst.comparacorsi.it"]');
}

function waitForStapeScript(script) {
  if (script.dataset.trackingReady === 'true') {
    flushEventQueue();
    return;
  }

  const markReady = () => {
    script.dataset.trackingReady = 'true';
    setTimeout(flushEventQueue, 100);
  };

  if (script.readyState === 'complete' || script.readyState === 'loaded') {
    markReady();
    return;
  }

  script.addEventListener('load', markReady, { once: true });
  script.addEventListener('error', () => flushEventQueue(), { once: true });
}

export function initDataLayer() {
  if (!isBrowser() || typeof document === 'undefined') return;

  window.dataLayer = window.dataLayer || [];

  const script = getStapeScript();
  if (script) {
    waitForStapeScript(script);
    return;
  }

  let attempts = 0;
  const poll = window.setInterval(() => {
    attempts += 1;
    const loadedScript = getStapeScript();
    if (loadedScript) {
      window.clearInterval(poll);
      waitForStapeScript(loadedScript);
      return;
    }
    if (attempts >= 20) {
      window.clearInterval(poll);
      flushEventQueue();
    }
  }, 100);
}

export function pushToDataLayer(payload) {
  if (!isBrowser()) return;
  window.dataLayer = window.dataLayer || [];
  if (dataLayerReady) {
    window.dataLayer.push(payload);
    return;
  }
  eventQueue.push(payload);
}
